// extracted by mini-css-extract-plugin
export default {"btnSwitch":"SwitchBtn_btnSwitch__S1cyX","switch":"SwitchBtn_switch__P2CeL","slider":"SwitchBtn_slider__u1o9F"};